import axios from "axios";
import { GetApiResponse } from "../types/api";
import { Login } from "../types/auth";
import Cookies from "js-cookie";
import { apiBaseUrl } from "./index";

const accessToken = () => Cookies.get("accessToken");

export const postLoginService = async ({
  email,
  password,
}: {
  email: string;
  password: string;
}) => {
  try {
    const response = await axios.post<GetApiResponse<Login>>(
      `${apiBaseUrl}/auth/token`,
      {
        email,
        password,
      },
    );

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const postRegisterService = async ({
  email,
  fullName,
  password,
  confirmPassword,
  affiliation,
  targetCountries,
}: {
  email: string;
  fullName: string;
  password: string;
  confirmPassword: string;
  affiliation: string;
  targetCountries: string;
}) => {
  try {
    const response = await axios.post<GetApiResponse<{ message: string }>>(
      `${apiBaseUrl}/auth/register`,
      {
        email,
        fullName,
        password,
        confirmPassword,
        affiliation,
        targetCountries,
        callbackUrl: `${window.location.origin}/verification`,
      },
    );

    return response.data;
  } catch (error: any) {
    return { ...error.response.data, email };
  }
};

export const postLogoutService = async () => {
  try {
    const response = await axios.post<GetApiResponse<any>>(
      `${apiBaseUrl}/auth/Logout`,
      null,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          ...(accessToken()
            ? { Authorization: `Bearer ${accessToken()}` }
            : {}),
        },
      },
    );

    return true;
  } catch (error) {
    throw error;
  }
};

export const postRefreshTokenService = async ({
  refreshToken,
}: {
  refreshToken: string;
}) => {
  try {
    const response = await axios.post<GetApiResponse<Login>>(
      `${apiBaseUrl}/auth/refresh`,
      {
        refreshToken,
      },
    );

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getEmailConfirmationService = async ({
  email,
  token,
}: {
  email?: string;
  token?: string;
}) => {
  try {
    const response = await axios.get<GetApiResponse<{ message: string }>>(
      `${apiBaseUrl}/auth/ConfirmEmail`,
      {
        params: {
          email,
          token,
        },
      },
    );

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getResetPasswordConfirmationService = async ({
  email,
  token,
}: {
  email?: string;
  token?: string;
}) => {
  try {
    const response = await axios.get<GetApiResponse<{ message: string }>>(
      `${apiBaseUrl}/auth/ResetPassword/verify`,
      {
        params: {
          email,
          token,
        },
      },
    );

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const postForgotPasswordService = async ({
  email,
}: {
  email: string;
}) => {
  try {
    const response = await axios.post<GetApiResponse<any>>(
      `${apiBaseUrl}/auth/ForgotPassword`,
      {
        email,
        callbackUrl: `${window.location.origin}/reset-password`,
      },
    );

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const postResendActivationService = async ({
  email,
}: {
  email: string;
}) => {
  try {
    const response = await axios.post<GetApiResponse<any>>(
      `${apiBaseUrl}/auth/ResendActivation`,
      {
        email,
        callbackUrl: `${window.location.origin}/verification`,
      },
    );

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const postResetPasswordService = async ({
  email,
  token,
  newPassword,
}: {
  email: string;
  token: string;
  newPassword: string;
}) => {
  try {
    const response = await axios.post<GetApiResponse<any>>(
      `${apiBaseUrl}/auth/ResetPassword`,
      {
        email,
        token,
        newPassword,
      },
    );

    return response.data;
  } catch (error) {
    throw error;
  }
};
